const utils = {
	NODE: "node",
	CONTROL_POINT: "controlPoint",

	norm: function (value, min, max) {
		return (value - min) / (max - min);
	},

	vector: function (x, y, x1, y1) {
		return [x - x1, y - y1];
	},

	lerp: function (norm, min, max) {
		return (max - min) * norm + min;
	},

	map: function (value, sourceMin, sourceMax, destMin, destMax) {
		return utils.lerp(
			utils.norm(value, sourceMin, sourceMax),
			destMin,
			destMax
		);
	},

	clamp: function (value, min, max) {
		return Math.min(
			Math.max(value, Math.min(min, max)),
			Math.max(min, max)
		);
	},

	distance: function (p0, p1) {
		var dx = p1.x - p0.x,
			dy = p1.y - p0.y;
		return Math.sqrt(dx * dx + dy * dy);
	},

	distanceXY: function (x0, y0, x1, y1) {
		var dx = x1 - x0,
			dy = y1 - y0;
		return Math.sqrt(dx * dx + dy * dy);
	},

	circleCollision: function (c0, c1) {
		return utils.distance(c0, c1) <= c0.radius + c1.radius;
	},

	circlePointCollision: function (x, y, circle) {
		return utils.distanceXY(x, y, circle.x, circle.y) < circle.radius;
	},

	pointInRect: function (x, y, rect) {
		return (
			utils.inRange(
				x,
				rect.x - rect.width / 2,
				rect.x + rect.width / 2
			) &&
			utils.inRange(y, rect.y - rect.height / 2, rect.y + rect.height / 2)
		);
	},

	inRange: function (value, min, max) {
		return value >= Math.min(min, max) && value <= Math.max(min, max);
	},

	rangeIntersect: function (min0, max0, min1, max1) {
		return (
			Math.max(min0, max0) >= Math.min(min1, max1) &&
			Math.min(min0, max0) <= Math.max(min1, max1)
		);
	},

	rectIntersect: function (r0, r1) {
		return (
			utils.rangeIntersect(
				r0.x,
				r0.x + r0.width,
				r1.x,
				r1.x + r1.width
			) &&
			utils.rangeIntersect(r0.y, r0.y + r0.height, r1.y, r1.y + r1.height)
		);
	},

	degreesToRads: function (degrees) {
		return (degrees / 180) * Math.PI;
	},

	radsToDegrees: function (radians) {
		return (radians * 180) / Math.PI;
	},

	randomRange: function (min, max) {
		return min + Math.random() * (max - min);
	},

	randomInt: function (min, max) {
		return Math.floor(min + Math.random() * (max - min + 1));
	},

	roundToPlaces: function (value, places) {
		var mult = Math.pow(10, places);
		return Math.round(value * mult) / mult;
	},

	roundNearest: function (value, nearest) {
		return Math.round(value / nearest) * nearest;
	},

	quadraticBezier: function (p0, p1, p2, t, pFinal) {
		pFinal = pFinal || {};
		pFinal.x =
			Math.pow(1 - t, 2) * p0.x + (1 - t) * 2 * t * p1.x + t * t * p2.x;
		pFinal.y =
			Math.pow(1 - t, 2) * p0.y + (1 - t) * 2 * t * p1.y + t * t * p2.y;
		return pFinal;
	},

	cubicBezier: function (p0, p1, p2, p3, t, pFinal) {
		pFinal = pFinal || {};
		pFinal.x =
			Math.pow(1 - t, 3) * p0.x +
			Math.pow(1 - t, 2) * 3 * t * p1.x +
			(1 - t) * 3 * t * t * p2.x +
			t * t * t * p3.x;
		pFinal.y =
			Math.pow(1 - t, 3) * p0.y +
			Math.pow(1 - t, 2) * 3 * t * p1.y +
			(1 - t) * 3 * t * t * p2.y +
			t * t * t * p3.y;
		return pFinal;
	},

	getControlPointPosition: function (startXPos, startYPos, endXPos, endYPos) {
		// Some math to have curve lines :)
		let distance = utils.distanceXY(startXPos, startYPos, endXPos, endYPos);
		if (distance <= 0) distance = 15;

		const radius = distance / 2;
		const angle = Math.asin((endYPos - startYPos) / distance);

		const xOffset = (startXPos + endXPos) / 2;
		const yOffset = (startYPos + endYPos) / 2;

		const controlPointXPos =
			xOffset + radius * Math.cos(angle - Math.PI / 2);
		const controlPointYPos =
			yOffset + radius * Math.sin(angle - Math.PI / 2);

		return [controlPointXPos, controlPointYPos];
	},

	// Thanks to: https://stackoverflow.com/a/9195706
	getQuadraticCurveBezierValue(t, p1, p2, p3) {
		const iT = 1 - t;
		return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
	},

	getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
		return {
			x: utils.getQuadraticCurveBezierValue(position, startX, cpX, endX),
			y: utils.getQuadraticCurveBezierValue(position, startY, cpY, endY),
		};
	},

	pointInHandle(x, y, handle) {
		return (
			utils.pointInRect(x, y, handle.rect) ||
			utils.circlePointCollision(x, y, handle.leftCircle) ||
			utils.circlePointCollision(x, y, handle.rightCircle)
		);
	},

	IDToIndex(array, id) {
		return array.findIndex((e) => e.id === id);
	},
	indexToID(array, index) {
		return array[index].id;
	},

	//#region DOWNLOAD
	download(path, filename) {
		// Create a new link
		const anchor = document.createElement("a");
		anchor.href = path;
		anchor.download = filename;
		document.body.appendChild(anchor);
		anchor.click();

		document.body.removeChild(anchor);
	},
	downloadImage(url, name) {
		if (url) {
			// This can be downloaded directly:
			var xhr = new XMLHttpRequest();
			xhr.responseType = "blob";
			xhr.onload = (event) => {
				var blob = xhr.response;
				const blobUrl = URL.createObjectURL(blob);
				utils.download(blobUrl, name);
			};
			xhr.open("GET", url);
			xhr.send();
		}
	},
	//#endregion

	monthIndexToName(index) {
		const months = [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre",
		]
		return months[index];
	}
};

export default utils;
